import actions from './actions'

const initialState = {
  // AI Agents
  aiAgentsList: [],
  aiAgentsListTotal: 0,
  aiAgentsListPagination: {},
  aiAgentSearchText: '',
  areAiAgentsLoading: false,
  deletingAgentIds: [],
  updatingAgentIds: [],
  aiAgentCreateForm: null,
  isAiAgentCreateFormLoading: false,
  aiAgentEditForm: null,
  isAiAgentEditFormLoading: false,
  aiAgentIntegrations: [],
  lastCreatedAgentId: null,
  // AI Agents Builder
  aiAgentsBuilderList: [],
  aiAgentsBuilderListTotal: 0,
  aiAgentsBuilderListPagination: {},
  aiAgentBuilderSearchText: '',
  areAiAgentsBuildersLoading: false,
  deletingAgentBuilderIds: [],
  updatingAgentBuilderIds: [],
  activeBuilderAgent: null,
  isActiveBuilderAgentLoading: false,
  aiAgentBuilderCreateForm: null,
  isAiAgentBuilderCreateFormLoading: false,
  aiAgentBuilderEditForm: null,
  isAiAgentBuilderEditFormLoading: false,
  aiAgentBuilderIntegrations: [],
  // AI Tools
  aiToolsList: [],
  aiToolsListTotal: 0,
  aiToolsListPagination: {},
  aiToolSearchText: '',
  areAiToolsLoading: false,
  currentAiTool: null,
  isCurrentAiToolLoading: false,
  aiToolEditForm: null,
  isAiToolEditFormLoading: false,
  aiToolCreateForm: null,
  isAiToolCreateFormLoading: false,
  // AI Actions
  aiActionsList: [],
  aiActionsListTotal: 0,
  aiActionsListPagination: {},
  aiActionSearchText: '',
  areAiActionsLoading: false,
  currentAiAction: null,
  isCurrentAiActionLoading: false,
  aiActionEditForm: null,
  isAiActionEditFormLoading: false,
  aiActionCreateForm: null,
  isAiActionCreateFormLoading: false,
  // AI Tools Builder
  aiToolsBuilderList: [],
  aiToolsBuilderListTotal: 0,
  aiToolsBuilderListPagination: {},
  aiToolBuilderSearchText: '',
  areAiToolsBuildersLoading: false,
  currentAiToolBuilder: null,
  isCurrentAiToolBuilderLoading: false,
  aiToolBuilderEditForm: null,
  isAiToolBuilderEditFormLoading: false,
  aiActionBuilderEditForm: null,
  isAiActionBuilderEditFormLoading: false,
  aiToolBuilderCreateForm: null,
  isAiToolBuilderCreateFormLoading: false,
  aiToolActionsList: [],
  aiToolActionsTotal: 0,
  aiToolActionsLoading: false,
  aiToolActionsPagination: {},
  currentAiToolActions: null,
  aiActionBuilderCreateForm: null,
  isAiActionBuilderCreateFormLoading: false,
  // Custom API Tools
  customApiToolsList: [],
  customApiToolsTotal: 0,
  customApiToolsLoading: false,
  customApiToolCreating: false,
  customApiToolUpdating: false,
  customApiToolsPagination: {},
  // Knowledge Base
  knowledgeBaseList: [],
  knowledgeBaseTotal: 0,
  knowledgeBaseLoading: false,
  knowledgeBasePagination: {},
  knowledgeBaseDetails: null,
  knowledgeBaseDetailsLoading: false,
  knowledgeBaseDetailsPagination: {},
  // MCP Servers
  mcpServersList: [],
  mcpServersTotal: 0,
  mcpServersLoading: false,
  mcpServersPagination: {},
  // Frontend Actions
  frontendActionsList: [],
  frontendActionsTotal: 0,
  frontendActionsLoading: false,
  frontendActionsError: null,
  frontendActionsPagination: {},
  frontendActionFormLoading: false,
  frontendActionDeleteLoading: false,
  // Available Models
  availableModels: [],
  availableModelsLoading: false,
  // AI Agent Users
  aiAgentUserList: [],
  aiAgentUserListTotal: 0,
  aiAgentUserListText: '',
  aiAgentUserSearchText: '',
  areAIAgentUsersLoading: false,
  aiAgentUserListPagination: {},
}

export default function aiAgentsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
